/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val2_DescInputs */

const en_st_val2_desc = /** @type {(inputs: St_Val2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your client sees which tasks passed their acceptance criteria, which were an exception and why — and approves each phase themselves.`)
};

const id_st_val2_desc = /** @type {(inputs: St_Val2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klien melihat task mana yang lulus kriteria penerimaan, mana yang jadi pengecualian dan kenapa — lalu menyetujui tiap fase sendiri.`)
};

/**
* | output |
* | --- |
* | "Your client sees which tasks passed their acceptance criteria, which were an exception and why — and approves each phase themselves." |
*
* @param {St_Val2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val2_desc = /** @type {((inputs?: St_Val2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val2_desc(inputs)
	return en_st_val2_desc(inputs)
});